// BEGIN seibertronSolagTThreeFingerlessRestore20260714
;(function seibertronSolagTThreeFingerlessRestore20260714() {
  var config = {
  "handle": "seibertron-men-or-women-xxs-to-xxl-fingerless-half-finger-sports-outdoor-tactical-gloves-1",
  "chartAssetName": "solagt-three-finger-tactical-size-chart-user-20260728-v1.jpg",
  "chartWidth": 1000,
  "chartHeight": 1000,
  "entries": [
    {
      "id": "33374854250686",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/solag-t-three-fingerless-gallery-09.jpg?v=1783400857",
      "alt": "color:Army Green | batch:solag-t-complete-20260716 | role:white-background-main | Seibertron S.O.L.A.G-T three fingerless tactical gloves army green white background main"
    },
    {
      "id": "33455609512126",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-army-green-detail-1-20260716.jpg?v=1784188460",
      "alt": "color:Army Green | batch:solag-t-complete-20260716 | role:detail-1 | Seibertron S.O.L.A.G-T three fingerless tactical gloves army green detail 1"
    },
    {
      "id": "33455609544894",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-army-green-detail-2-20260716.jpg?v=1784188460",
      "alt": "color:Army Green | batch:solag-t-complete-20260716 | role:detail-2 | Seibertron S.O.L.A.G-T three fingerless tactical gloves army green detail 2"
    },
    {
      "id": "33455609577662",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-army-green-detail-3-20260716.jpg?v=1784188460",
      "alt": "color:Army Green | batch:solag-t-complete-20260716 | role:detail-3 | Seibertron S.O.L.A.G-T three fingerless tactical gloves army green detail 3"
    },
    {
      "id": "33455609610430",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-army-green-detail-4-20260716.jpg?v=1784188460",
      "alt": "color:Army Green | batch:solag-t-complete-20260716 | role:detail-4 | Seibertron S.O.L.A.G-T three fingerless tactical gloves army green detail 4"
    },
    {
      "id": "33455609643198",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-army-green-detail-5-20260716.jpg?v=1784188460",
      "alt": "color:Army Green | batch:solag-t-complete-20260716 | role:detail-5 | Seibertron S.O.L.A.G-T three fingerless tactical gloves army green detail 5"
    },
    {
      "id": "33455609675966",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-army-green-detail-6-20260716.jpg?v=1784188460",
      "alt": "color:Army Green | batch:solag-t-complete-20260716 | role:detail-6 | Seibertron S.O.L.A.G-T three fingerless tactical gloves army green detail 6"
    },
    {
      "id": "33374853988542",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/solag-t-three-fingerless-gallery-01.jpg?v=1783400857",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:white-background-main | Seibertron S.O.L.A.G-T three fingerless tactical gloves black white background main"
    },
    {
      "id": "33455609708734",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-1-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-1 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 1"
    },
    {
      "id": "33455609741502",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-2-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-2 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 2"
    },
    {
      "id": "33455609774270",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-3-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-3 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 3"
    },
    {
      "id": "33455609807038",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-4-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-4 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 4"
    },
    {
      "id": "33455609839806",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-5-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-5 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 5"
    },
    {
      "id": "33455609872574",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-6-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-6 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 6"
    },
    {
      "id": "33455609905342",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-7-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-7 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 7"
    },
    {
      "id": "33455609938110",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-8-20260716.jpg?v=1784188460",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-8 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 8"
    },
    {
      "id": "33455609970878",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-black-detail-9-20260716.jpg?v=1784188459",
      "alt": "color:Black | batch:solag-t-complete-20260716 | role:detail-9 | Seibertron S.O.L.A.G-T three fingerless tactical gloves black detail 9"
    },
    {
      "id": "33374854119614",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/solag-t-three-fingerless-gallery-05.jpg?v=1783400857",
      "alt": "color:Grey | batch:solag-t-complete-20260716 | role:white-background-main | Seibertron S.O.L.A.G-T three fingerless tactical gloves grey white background main"
    },
    {
      "id": "33455610003646",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-grey-detail-1-20260716.jpg?v=1784188460",
      "alt": "color:Grey | batch:solag-t-complete-20260716 | role:detail-1 | Seibertron S.O.L.A.G-T three fingerless tactical gloves grey detail 1"
    },
    {
      "id": "33455610036414",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-grey-detail-2-20260716.jpg?v=1784188460",
      "alt": "color:Grey | batch:solag-t-complete-20260716 | role:detail-2 | Seibertron S.O.L.A.G-T three fingerless tactical gloves grey detail 2"
    },
    {
      "id": "33455610069182",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-grey-detail-3-20260716.jpg?v=1784188460",
      "alt": "color:Grey | batch:solag-t-complete-20260716 | role:detail-3 | Seibertron S.O.L.A.G-T three fingerless tactical gloves grey detail 3"
    },
    {
      "id": "33455610101950",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-grey-detail-4-20260716.jpg?v=1784188460",
      "alt": "color:Grey | batch:solag-t-complete-20260716 | role:detail-4 | Seibertron S.O.L.A.G-T three fingerless tactical gloves grey detail 4"
    },
    {
      "id": "33455610134718",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-grey-detail-5-20260716.jpg?v=1784188460",
      "alt": "color:Grey | batch:solag-t-complete-20260716 | role:detail-5 | Seibertron S.O.L.A.G-T three fingerless tactical gloves grey detail 5"
    },
    {
      "id": "33374854381758",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/solag-t-three-fingerless-gallery-13.jpg?v=1783400857",
      "alt": "color:Coyote | batch:solag-t-complete-20260716 | role:white-background-main | Seibertron S.O.L.A.G-T three fingerless tactical gloves coyote white background main"
    },
    {
      "id": "33455610167486",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-coyote-detail-1-20260716.jpg?v=1784188460",
      "alt": "color:Coyote | batch:solag-t-complete-20260716 | role:detail-1 | Seibertron S.O.L.A.G-T three fingerless tactical gloves coyote detail 1"
    },
    {
      "id": "33455610200254",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-coyote-detail-2-20260716.jpg?v=1784188460",
      "alt": "color:Coyote | batch:solag-t-complete-20260716 | role:detail-2 | Seibertron S.O.L.A.G-T three fingerless tactical gloves coyote detail 2"
    },
    {
      "id": "33455610233022",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-coyote-detail-3-20260716.jpg?v=1784188460",
      "alt": "color:Coyote | batch:solag-t-complete-20260716 | role:detail-3 | Seibertron S.O.L.A.G-T three fingerless tactical gloves coyote detail 3"
    },
    {
      "id": "33455610265790",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-coyote-detail-4-20260716.jpg?v=1784188460",
      "alt": "color:Coyote | batch:solag-t-complete-20260716 | role:detail-4 | Seibertron S.O.L.A.G-T three fingerless tactical gloves coyote detail 4"
    },
    {
      "id": "33455610298558",
      "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-solag-t-three-fingerless-coyote-detail-5-20260716.jpg?v=1784188460",
      "alt": "color:Coyote | batch:solag-t-complete-20260716 | role:detail-5 | Seibertron S.O.L.A.G-T three fingerless tactical gloves coyote detail 5"
    }
  ],
  "groups": {
    "Army Green": [
      "33374854250686",
      "33455609512126",
      "33455609544894",
      "33455609577662",
      "33455609610430",
      "33455609643198",
      "33455609675966"
    ],
    "Black": [
      "33374853988542",
      "33455609708734",
      "33455609741502",
      "33455609774270",
      "33455609807038",
      "33455609839806",
      "33455609872574",
      "33455609905342",
      "33455609938110",
      "33455609970878"
    ],
    "Grey": [
      "33374854119614",
      "33455610003646",
      "33455610036414",
      "33455610069182",
      "33455610101950",
      "33455610134718"
    ],
    "Coyote": [
      "33374854381758",
      "33455610167486",
      "33455610200254",
      "33455610233022",
      "33455610265790",
      "33455610298558"
    ]
  }
};
  var entryById = {};
  config.entries.forEach(function (entry) { entryById[String(entry.id)] = entry; });
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function scriptAssetUrl(assetName) {
    var own = Array.prototype.find.call(document.scripts, function (script) {
      return script.src && script.src.indexOf('solag-t-three-fingerless-gallery-restore-20260714.js') !== -1;
    });
    if (own) return own.src.replace('solag-t-three-fingerless-gallery-restore-20260714.js', assetName);
    return '/cdn/shop/files/' + assetName;
  }
  function selectedColor(root) {
    var checked = root.querySelector('[data-auto-visual-option-value] input:checked, input[name="options[Color]"]:checked, input[name="options[color]"]:checked');
    if (!checked) return 'Army Green';
    var label = checked.closest ? checked.closest('[data-auto-visual-option-value]') : null;
    return (label && label.getAttribute('data-auto-visual-option-value')) || checked.value || 'Army Green';
  }
  function groupFor(color) {
    return (config.groups[color] || config.groups['Army Green'] || []).map(function (id) { return entryById[String(id)]; }).filter(Boolean);
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function ensureThumb(root, wrap, entry, index, visibleIds) {
    var id = String(entry.id);
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.hidden = false;
    thumb.style.display = '';
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.onclick = function () {
      setMain(root, entry);
      root.querySelectorAll('[data-auto-thumb]').forEach(function (node) {
        node.classList.toggle('is-active', node === thumb);
      });
    };
    visibleIds[id] = true;
  }
  function showGroup(root, color) {
    var wrap = root.querySelector('.auto-product__thumbs');
    var group = groupFor(color);
    if (!group.length) return;
    var visibleIds = {};
    if (wrap) {
      group.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index, visibleIds); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var show = !!visibleIds[String(thumb.getAttribute('data-media-id') || '')];
        thumb.hidden = !show;
        thumb.style.display = show ? '' : 'none';
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
        thumb.classList.toggle('is-active', show && thumb.getAttribute('data-media-id') === String(group[0].id));
      });
    }
    setMain(root, group[0]);
  }
  function hydrateSwatches(root) {
    Object.keys(config.groups).forEach(function (color) {
      var first = groupFor(color)[0];
      if (!first) return;
      root.querySelectorAll('[data-auto-visual-option-value="' + color + '"], [data-auto-color-value="' + color + '"]').forEach(function (label) {
        var shell = label.querySelector('[data-auto-choice-label]');
        if (!shell) return;
        shell.dataset.display = color;
        shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(color) + '"><img src="' + escapeHtml(sized(first.src, 180)) + '" alt="' + escapeHtml(color) + '" width="72" height="72" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(color) + '</span>';
      });
    });
  }
  function replaceChart(root) {
    var img = root.querySelector('img.auto-product__guide-image');
    if (!img) return;
    img.src = scriptAssetUrl(config.chartAssetName);
    img.srcset = '';
    img.width = config.chartWidth;
    img.height = config.chartHeight;
    img.alt = 'Seibertron S.O.L.A.G-T three fingerless tactical adult gloves size chart with palm circumference measurement method';
  }
  function ensureStyle() {
    var id = 'solag-t-three-fingerless-restore-style-20260714';
    if (document.getElementById(id)) return;
    var style = document.createElement('style');
    style.id = id;
    style.textContent = '.auto-product[data-product-handle="' + config.handle + '"] [data-auto-visual-option-value] [data-auto-choice-label]{width:78px;height:78px;min-width:78px;padding:0!important;overflow:hidden;display:flex;align-items:center;justify-content:center;background:#fff}.auto-product[data-product-handle="' + config.handle + '"] .auto-product__swatch-image{width:100%;height:100%;display:block}.auto-product[data-product-handle="' + config.handle + '"] .auto-product__swatch-image img{width:100%;height:100%;object-fit:cover;background:#fff;display:block}.auto-product[data-product-handle="' + config.handle + '"] .auto-product__swatch-label{position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important}';
    document.head.appendChild(style);
  }
  function run(forceColor) {
    document.querySelectorAll('.auto-product[data-product-handle="' + config.handle + '"]').forEach(function (root) {
      ensureStyle();
      replaceChart(root);
      hydrateSwatches(root);
      showGroup(root, forceColor || selectedColor(root));
      if (root.dataset.solagTThreeFingerlessRestoreBound === 'true') return;
      root.dataset.solagTThreeFingerlessRestoreBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          var color = selectedColor(root);
          [0, 150, 600, 1300].forEach(function (delay) {
            window.setTimeout(function () { run(color); }, delay);
          });
        }
      });
      root.addEventListener('click', function (event) {
        var label = event.target && event.target.closest ? event.target.closest('[data-auto-visual-option-value]') : null;
        if (!label) return;
        var color = label.getAttribute('data-auto-visual-option-value') || selectedColor(root);
        [0, 120, 500, 1000].forEach(function (delay) {
          window.setTimeout(function () { run(color); }, delay);
        });
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }, { once: true });
  else run();
  [250, 800, 1600, 3200, 5200, 8200].forEach(function (delay) { window.setTimeout(function () { run(); }, delay); });
})();
// END seibertronSolagTThreeFingerlessRestore20260714
